<form class="send-form" [formGroup]="sendMessageForm">

    <textarea formControlName="message"
              class="send-textarea"
              placeholder="Escribe tu mensaje..."
              maxlength="2042"
              rows="4"
              (keyup)="contador($event)"></textarea>

    <div class="send-footer">

        <span class="send-counter">{{ contadorInit }}/2042</span>

        <div class="send-actions">

            <!-- Adjuntar documento -->
            <div class="attach-wrapper">

                <ngfFormData [files]="files" postName="file" [(FormData)]="uploadFormData"></ngfFormData>

                <div *ngIf="files.length === 0"
                     ngfDrop selectable="1"
                     [(validDrag)]="validComboDrag"
                     [(files)]="files"
                     [(dragFiles)]="dragFiles"
                     class="attach-button"
                     [class.attach-button--valid]="validComboDrag === true"
                     [class.attach-button--invalid]="validComboDrag === false"
                     (filesChange)="lastFileAt = getDate()">
                    <span class="attach-button-icon" aria-hidden="true">
                        <svg viewBox="0 0 16 16" fill="none" stroke="#00558c"
                             stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M13 7.5l-5 5a3 3 0 0 1-4.24-4.24l5.3-5.3a2 2 0 0 1 2.83 2.83L7.06 11.1"/>
                        </svg>
                    </span>
                    <span class="attach-button-label">ADJUNTAR DOCUMENTO</span>
                </div>

                <div class="attach-file" *ngIf="files.length > 0 && checkFile()">
                    <span class="attach-file-name">{{ files[0].name }}</span>
                    <span class="attach-file-size">{{ files[0].size / 1024 / 1024 | number: ".2" }} MB</span>
                    <button type="button" class="attach-file-remove"
                            (click)="files.splice(0, 1)"
                            aria-label="Quitar adjunto">×</button>
                </div>

            </div>

            <!-- Enviar -->
            <button type="button" class="send-button"
                    [disabled]="!sendMessageForm.valid || sending"
                    (click)="sendMessage()">
                <span class="send-button-spinner" *ngIf="sending" aria-hidden="true"></span>
                <span class="send-button-icon" *ngIf="!sending" aria-hidden="true">
                    <svg viewBox="0 0 16 16" fill="none" stroke="#ffffff"
                         stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M2 8l12-6-6 12-2-4-4-2z"/>
                    </svg>
                </span>
                <span class="send-button-label">ENVIAR</span>
            </button>

        </div>

    </div>

</form>
